import React from 'react';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';

const StyledTextField = ({ 
  label,
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  fullWidth = true,
  variant = 'outlined',
  ...props 
}) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      variant={variant}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          backgroundColor: 'var(--background-alt)',
          '& fieldset': {
            borderColor: 'var(--border)',
          },
          '&:hover fieldset': {
            borderColor: 'var(--primary)',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'var(--primary)',
          },
          '&.Mui-error fieldset': {
            borderColor: 'var(--error)',
          }
        },
        '& .MuiInputLabel-root': {
          color: 'var(--text-secondary)',
          '&.Mui-focused': {
            color: 'var(--primary)',
          },
          '&.Mui-error': {
            color: 'var(--error)',
          }
        },
        '& .MuiFormHelperText-root': {
          fontSize: '0.875rem',
          '&.Mui-error': {
            color: 'var(--error)',
          }
        },
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        borderRadius: 2,
        ...props.sx
      }}
      {...props}
    />
  );
};

StyledTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  sx: PropTypes.object
};

export default StyledTextField;